import React, { useState, useEffect } from "react";
import { FieldsReducer } from "src/CommonComponents/Reducer/Index";
import { useFetch } from "src/hooks/useFetch";
import { GetFullURL } from "src/CommonComponents/GlobalConfFiles/URLs";
import Button from "react-bootstrap/Button";
import { useMessage } from "src/hooks/UseMessage";
import { useNavigate } from "react-router-dom";
import MessageLog from "src/CommonComponents/Messages/MessageLog";
import { LoadingScreen } from "src/CommonComponents/LoadingScreen/index";
import Card from "src/CommonComponents/Card";
import additionalinfo from "src/Assets/info2.svg";
import LineChart from "src/CommonComponents/Charts/LineChart/LineChart";
import * as _ from "underscore";

export default function GlendaleBOLProcessTimeChart() {
  let navigate = useNavigate();
  const [reportParam, setReportParam] = useState();
  const [reportData, setReportData] = useState({});
  const [showReport, setShowReport] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  const [xaxisName, setXaxisName] = useState("");
  const [yaxisName, setYaxisName] = useState("");
  const [chartName, setChartName] = useState("");
  const [numberOfCharts, setNumberOfCharts] = useState(0);
  const [chartIndex, setChartIndex] = useState(0);
  const [filteredCharts, setFilteredCharts] = useState([{}]);
  const [counter, setCounter] = useState(0);
  const [date, setDate] = useState("");

  const [
    _getChartData,
    _chartData,
    ,
    _errorChartData,
    _setErrorChartData,
    _successChartData,
    _setSuccessChartData,
    _loadingChartData,
  ] = useFetch(GetFullURL("BOLProcessTimeChart"), { method: "POST" });

  const [
    _getGeneralDD,
    _GeneralDDData,
    ,
    _errorGeneralDD,
    _setErrorGeneralDD,
    _successGeneralDD,
    _setSuccessGeneralDD,
    _loadingGeneralDD,
  ] = useFetch(GetFullURL("GetGeneralDropDown"), { method: "POST" });

  const operationLoading = _loadingChartData || _loadingGeneralDD;

  function clearMessages(e) {
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessChartData([]);
        _setSuccessGeneralDD([]);
        break;
      case "error":
        _setErorMessages([]);
        _setErrorChartData([]);
        _setErrorGeneralDD([]);
        break;
      default:
        break;
    }
  }

  //this function splits array to chunks of certain dates
  const splitEntries = (data) => {
    let chunkSize = data.amountOfChunk;
    setNumberOfCharts(chunkSize);
    let x = 0;
    const res = [];
    for (let i = 0; i < chunkSize; i++) {
      for (let j = 0; j < data.processTimeItems.length; j++) {
        if (
          data.processTimeItems[j].shipDocDate ===
          data.filteredItems[i].shipDocDate
        ) {
          if (x === 0) {
            x = 1;
            const chunk = data.processTimeItems.filter(
              (x) => x.shipDocDate === data.filteredItems[i].shipDocDate
            );
            res.push(chunk);
          }
        }
      }
      x = 0;
    }

    setFilteredCharts(res);

    if (res.length != 0) {
      let id = res[0]?.map((x) => x.id);
      let time = res[0]?.map((x) => x.differenceInTime);
      let value = res[0]?.map((x) => x.chartValue);
      let bolDate = res[0]?.map((x) => x.shipDocDate);
      setReportData({
        ids: id,
        differenceInTime: time,
        chartValue: value,
        dates: bolDate,
      });

      setCounter(res[0].length);
      let date = bolDate[0];
      setDate(date.slice(0, 10));
      setShowReport(true);
    }
  };

  useEffect(() => {
    setChartIndex(0);
    _getChartData(
      {
        data: {
          LocationId: "4001",
        },
      },
      ({ data }) => {
        if (data.length == 0) {
          _createErrorMessage("90");
          return;
        }
        splitEntries(data);
      }
    );
  }, []);

  useEffect(() => {
    if (!_.isEmpty(filteredCharts[0])) {
      let id = filteredCharts[chartIndex].map((x) => x.id);
      let time = filteredCharts[chartIndex].map((x) => x.differenceInTime);
      let value = filteredCharts[chartIndex].map((x) => x.chartValue);
      let bolDate = filteredCharts[chartIndex].map((x) => x.shipDocDate);
      setReportData({
        ids: id,
        differenceInTime: time,
        chartValue: value,
        dates: bolDate,
      });

      setCounter(filteredCharts[chartIndex].length);
      let date = bolDate[0];
      setDate(date.slice(0, 10));
      setShowReport(true);
    }
  }, [chartIndex]);

  const style = {
    marginLeft: "30px",
  };

  if (showReport) {
    return (
      <div>
        {operationLoading && <LoadingScreen />}
        <h1 style={style}>
          {" "}
          Date : {date} , Number of BOLs: {counter}
        </h1>
        <LineChart
          name={"BOL Process Time in min"}
          {...reportData}
          yaxisName={yaxisName}
        />
        <div className="column" style={style}>
          {" "}
          <div className="row mt-3">
            <Button
              onClick={() => {
                if (chartIndex >= numberOfCharts - 1) {
                  return;
                }

                setChartIndex(chartIndex + 1);
                setShowReport(false);
                setCounter(filteredCharts[chartIndex].length);
              }}
              style={{
                width: "10%",
                background: "#3e8e41",
                borderColor: "#3e8e41",
              }}
            >
              Next
            </Button>
          </div>
          <div className="row mt-3">
            <Button
              onClick={() => {
                if (chartIndex <= 0) {
                  return;
                }
                setChartIndex(chartIndex - 1);
                setShowReport(false);
                setCounter(filteredCharts[chartIndex].length);
              }}
              style={{
                width: "10%",
                background: "#D4AC0D",
                borderColor: "#D4AC0D",
              }}
            >
              Previous
            </Button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row">
        <div className="col-12 mt-3">
          <MessageLog
            errorMessages={[..._errorChartData, ..._errorMessages]}
            successMessages={[]}
            warningMessages={[]}
            clearMessages={clearMessages}
          ></MessageLog>
        </div>
      </div>
    );
  }
}
